module.exports = __webpack_public_path__ + "static/media/sv.c37f1b98.svg";